export default __webpack_public_path__ + "static/media/telegram.10009918.png";